import script from "./new-lark-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./new-lark-dialog.vue?vue&type=script&setup=true&lang=js"

import "./new-lark-dialog.vue?vue&type=style&index=0&id=ee9a019c&lang=scss"
import "./new-lark-dialog.vue?vue&type=style&index=1&id=ee9a019c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9a019c"]])

export default __exports__